import { Component } from '@angular/core';

@Component({
  selector: 'app-validacion-codigo-inquilino',
  standalone: false,
  templateUrl: './validacion-codigo-inquilino.component.html',
  styleUrl: './validacion-codigo-inquilino.component.scss'
})
export class ValidacionCodigoInquilinoComponent {

}
